var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isClosed)?_c('closed-page'):_c('home-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }